export const rtfoConfig = {
  dataProviders: ['MRL', 'Coldbore', 'Peloton', 'Fracpro', 'Abra', 'Manual', 'Other'],
  formations: [
    'Montney',
    'Duvernay',
    'Cardium',
    'Velkerri B',
    'Other'
  ],
  areas: ['Kakwa NW', 'Kakwa', 'Karr', 'Kaybob', 'Berland River', 'Valhalla', 'Cardium', 'Inga', 'Twining', 'Simonette', 'Carpentaria', 'Lator', 'Cygnet', 'Musreau', 'Mica', 'Other'],
  clients: ['Whitecap', 'Yangarra', 'Artis Exploration', 'Yoho Resources', 'Kiwetinohk', 'Empire Energy', 'Vesta Energy', 'Baytex', 'Ovintiv', 'Vermilion Energy', 'Other'],
  monitorProviders: ['-', 'Bonetts', 'Tronic', 'Coldbore', 'Abra', 'Critical Control'],
  seismicProviders: ['-', 'Spectraseis', 'Nanometrics']
};

export function getRTFOCompanyName(clientName) {
  if (clientName === 'wcap') {
    return 'Whitecap Resources';
  } else {
    return rtfoConfig?.clients?.find(c => c.toLowerCase().includes(clientName));
  };
};

export function stripMonitorUWI(uwi) {
  try {
    if (typeof uwi !== 'string') return '';

    return uwi.replace(/[^\d\w]/ig, '')?.substring(0, 7);
  } catch(error) {
    console.log(error);
    return uwi;
  };
};

export function getRTFOClientName(email) {
  try {
    return (
      (email?.toLowerCase()?.includes('wcap') || email === 'aborisov@ssdynamics.com' || email === 'tbailey99@gmail.com' || email === 'allan001@live.com' || email === 'tyler.labbe@hpstim.com') ? 'wcap' : 
      (email?.toLowerCase()?.includes('yangarra')) ? 'yangarra' : 
      (email?.toLowerCase()?.includes('yoho') || email === 'clive.mountford@outlook.com') ? 'yoho' : 
      (email?.toLowerCase()?.includes('artis')) ? 'artis' : 
      (email?.toLowerCase()?.includes('kiwetinohk')) ? 'kiwetinohk' : 
      (email?.toLowerCase()?.includes('empire')) ? 'empire' : 
      (email?.toLowerCase()?.includes('vesta')) ? 'vesta' : 
      (email?.toLowerCase()?.includes('baytex')) ? 'baytex' : 
      (email?.toLowerCase()?.includes('ovintiv')) ? 'ovintiv' : 
      (email?.toLowerCase()?.includes('vermilion') || email === 'mattbrooks1@gmail.com') ? 'vermilion' : 
      (email === 'demo@ssdynamics.com' || email === 'demo_admin@ssdynamics.com') ? 'other' : ''
    );
  } catch(error) {
    console.log(error);
    return 'other';
  };
};

export function isRTFOAdminUser(email) {
  try {
    return (email?.includes('admin@ssdynamics.com') || email === 'aborisov@ssdynamics.com') ? true : false;
  } catch(error) {
    console.log(error);
    return false;
  };
};

